// theme.ts
// 1. import `extendTheme` function
import { mode } from '@chakra-ui/theme-tools';
import { extendTheme } from '@chakra-ui/react';
// 2. Add your color mode config
var config = {
    initialColorMode: 'dark',
    useSystemColorMode: false,
};
var styles = {
    global: function (props) { return ({
        body: {
            color: mode('gray.800', 'whiteAlpha.900')(props),
            bg: mode('gray.100', '#0E041F')(props),
        },
    }); },
};
// 3. extend the theme
var customTheme = extendTheme({ config: config, styles: styles });
export default customTheme;
